import { Select } from "@mui/material";
import { styled } from "@mui/system";

const StyledSelect = styled(Select)(({ theme }) => {
  return {
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: '4px',
    },

    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":{
      borderColor: theme.palette.primary.light,
      borderWidth: 1,
    },

    "& .Mui-error": {
      borderColor: theme.palette.error.main,
      backgroundColor: theme.palette.primary.main,

      "&.MuiFormHelperText-root": {
        background: "none",
      },
    },
  };
});

export default StyledSelect;
